import { cn } from "@/lib/utils";

interface ArrowSpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

const sizes = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 40,
};

/**
 * Branded arrow loading spinner — loops the stroke-draw animation.
 * Drop-in replacement for Loader2 animate-spin.
 */
const ArrowSpinner = ({ className, size = "md" }: ArrowSpinnerProps) => {
  const px = sizes[size];
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("arrow-spinner", className)}
      aria-label="Loading"
    >
      <line
        x1="14" y1="50" x2="50" y2="14"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        className="arrow-spinner-line"
      />
      <polyline
        points="30,14 50,14 50,34"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="arrow-spinner-head"
      />
    </svg>
  );
};

export default ArrowSpinner;
